import {
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_SUCCESS,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_FAIL,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_SUCCESS,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_FAIL,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  goodServicesSubHead: [],
  addGoodServicesSubHead: [],
  goodServicesSubHeadDetail: {},
  error: {},
  loading: true,
}

const goodServicesSubHeadMaster = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_SUCCESS:
      return {
        ...state,
        goodServicesSubHead: action.payload,
        loading: false,
      }

    case GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_SUCCESS:
      return {
        ...state,
        goodServicesSubHeadDetail: action.payload,
        loading: false,
      }

    case GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        addGoodServicesSubHead: [...state.addGoodServicesSubHead, action.payload],
      }

    case ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        addGoodServicesSubHead: state.addGoodServicesSubHead.map(goodServicesSubHead =>
          goodServicesSubHead.id === action.payload.id ? { ...goodServicesSubHead, ...action.payload } : goodServicesSubHead
        ),
      }

    case UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        goodServicesSubHead: state.goodServicesSubHead.data.filter(
          goodServicesSubHead => goodServicesSubHead.id.toString() !== action.payload.toString()
        ),
      }

    case DELETE_GOOD_SERVICES_SUB_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default goodServicesSubHeadMaster
